/* eslint-disable sort-keys */
import { createSelector } from 'reselect';

export const meteredUsageSelector = createSelector(state => state, (reduxState) => {
  const { contractData } = reduxState;
  const contractFilters = ! contractData || ! contractData.length ? null : contractData[0];
  const filters = reduxState.presistFilters;
  const { aggregate_by, region_name } = filters;
  const result = {
    ...reduxState,
    filters: contractFilters ? {
      ...filters,
      start_date: contractFilters.start_date,
      end_date: contractFilters.end_date
    } : filters,
    contractFilters: contractFilters ? {
      ...contractFilters,
      aggregate_by,
      region: region_name
    } : null,
    contractTerms: {
      'contract.contractStartDate': {
        type: 'date',
        value: contractFilters ? contractFilters.start_date : null,
      },
      'contract.contractEndDate': {
        type: 'date',
        value: contractFilters ? contractFilters.end_date : null,
      },
      'transactions.totalPurchased': {
        type: 'strValue',
        value: contractFilters ? contractFilters.purchased_transactions : null,
      },
    },

  };

  return result;
});
